<div class="mt-5 overflow-auto centered">
    <!-- <app-pull-to-refresh (onPull)="reload()" [refresh]="dom_elements.refresh_is_running"> -->
        <div *ngIf="dom_elements.active_step === 0">
                <div class="form-group">

                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="exampleRadios" id="nazionaliRadio" value="1"
                               checked (change)="parkChanged($event)">
                        <label class="form-check-label" for="nazionaliRadio">
                            Parchi Nazionali
                        </label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="exampleRadios" id="militariRadio" value="2"
                               (change)="parkChanged($event)">
                        <label class="form-check-label" for="militariRadio">
                          Parchi Corpo Militare Volontario
                        </label>
                    </div>
                    <div class="form-check disabled">
                        <input class="form-check-input" type="radio" name="exampleRadios" id="iivvRadio" value="3"
                               (change)="parkChanged($event)">
                        <label class="form-check-label" for="iivvRadio">
                            Parchi Infermiere Volontarie
                        </label>
                    </div>
                    <div class="form-check disabled">
                        <input class="form-check-input" type="radio" name="exampleRadios" id="localRadio" value="4"
                               (change)="parkChanged($event)">
                        <label class="form-check-label" for="localRadio">
                            Parchi Comitati Locali
                        </label>
                    </div>
                    <div class="form-check disabled" [hidden]="vehicles_can_drive.length == 0">
                        <input class="form-check-input" type="radio" name="exampleRadios" id="candriveRadio" value="5"
                               (change)="parkChanged($event)">
                        <label class="form-check-label" for="candriveRadio">
                            Auto Autorizzate
                        </label>
                    </div>

                    <div [hidden]="dom_elements.show_can_drive" class="mt-3">
                        <label for="parcoMezziSelect">Scegli parco o mezzo autorizzato</label>
                        <select class="form-control" id="parcoMezziSelect" [(ngModel)]="selected_entity">
                            <option *ngFor="let entity of dom_elements.visible_parks" [ngValue]="entity">
                                {{ entity['name'] }}
                            </option>
                        </select>
                    </div>

                    <div [hidden]="!dom_elements.show_can_drive" class="mt-3">
                        <label for="canDriveSelect">Scegli autovettura</label>
                        <select class="form-control" id="canDriveSelect" [(ngModel)]="selected_entity">
                            <option *ngFor="let entity of vehicles_can_drive" [ngValue]="entity">
                                {{ entity['plate']+' - '+entity['park']['name'] }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Richiedi da</span>
                    </div>
                    <input type="text"
                           class="form-control"
                           style="height: auto;"
                           #dp="bsDatepicker"
                           bsDatepicker
                           [bsConfig]="{dateInputFormat: 'D/MM/YYYY', showWeekNumbers: false}"
                           [(bsValue)]="travel.required_from"
                           [disabled]="travel.travelStarted()"
                           [minDate]="fromMinDate"
                           [maxDate]="maxDate"
                           (bsValueChange)="onFromDateChange($event)"
                    >
                    <timepicker [(ngModel)]="travel.required_from"
                                [showMeridian]="false" [disabled]="travel.travelStarted()"
                                [min]="fromMinDate" [max]="maxDate">

                    </timepicker>
                </div>

                <!--value="{{ dateHandlerService.formatDateClassic(travel.required_from) }}"-->
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Richiedi a &nbsp;</span>
                    </div>
                    <input type="text"
                           class="form-control"
                           #dp="bsDatepicker"
                           style="height: auto;"
                           bsDatepicker
                           [bsConfig]="{dateInputFormat: 'D/MM/YYYY', showWeekNumbers: false}"
                           [(bsValue)]="travel.required_to"
                           [disabled]="travel.travelStarted()"
                           [minDate]="toMinDate"
                           [maxDate]="maxDate"
                    >

                    <timepicker [(ngModel)]="travel.required_to"
                                [showMeridian]="false" [disabled]="travel.travelStarted()" [min]="toMinDate" [max]="maxDate">

                    </timepicker>
                </div>

                <div class="my-3">
                    <label for="motivazione">Scegli motivazione</label>
                    <select class="form-control" id="motivazione" [(ngModel)]="selectedMotivation" (change)="onMotivationChange($event)">
                        <option *ngFor="let motivation of travelMotivations" [ngValue]="motivation">
                            {{ motivation['name'] }}
                        </option>
                    </select>
                </div>


                <div *ngIf="selectedMotivation?.id === 3" class="form-group">
                    <label for="motivazione-altro">Motivazione - Altro</label>
                    <textarea class="form-control height250"  id="motivazione-altro"
                              [(ngModel)]="travel.motivation_other" maxlength="80"></textarea>
                </div>


                <div class="form-group">
                    <label for="passengers">Persone Trasportate</label>
                    <textarea class="form-control height250"  id="passengers"
                              [(ngModel)]="travel.passengers" maxlength="80"></textarea>
                </div>

                <app-itinerario [itinerario]="itinerario" [modifications]="false"></app-itinerario>

                <button type="button" class="btn btn-outline-primary float-right ml-3 mt-5"
                        (click)="requestTravel()"
                        [disabled]="dom_elements.askTrip.is_running">
                    {{ dom_elements.askTrip.is_running ? dom_elements.askTrip.txt_run : dom_elements.askTrip.txt_not_run }}
                </button>

        </div>

    <!-- </app-pull-to-refresh> -->

</div>
